/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Link/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconExternalLink from 'DesignSystem/Svgs/TysiaIconExternalLink/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Link({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/Apps/Content/App/Link"
  
}) {
let appWebsiteValueData = fromData.useDataValue({ viewPath,
context: 'app',
path: 'website',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<a
 href={appWebsiteValueData} rel='noopener noreferrer' target='_blank'
  data-testid="Link.Vertical"
  data-view-path={viewPath}
 title={appWebsiteValueData}
 style={{'--ml-1-aqwu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaIconExternalLink
  viewPath={`${viewPath}/TysiaIconExternalLink`}
/>
</a>
{children}
</React.Fragment>)
}